import { render, staticRenderFns } from "./OmsSteps.vue?vue&type=template&id=07ae8ade&scoped=true"
import script from "./OmsSteps.vue?vue&type=script&lang=js"
export * from "./OmsSteps.vue?vue&type=script&lang=js"
import style0 from "./OmsSteps.vue?vue&type=style&index=0&id=07ae8ade&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ae8ade",
  null
  
)

export default component.exports